import React, { useEffect, useState } from "react";
import DiaglogBox from "../DiaglogBox";
import Line from "../HorizontalLine";
import Button from "../Button";
import DownloadButton from "../DownloadButton";
import UploadDocumentItem from "../../molecules/DocumnetUploadDialogBox/UploadDocumentItem";
import Input from "../Input";
import { getContentByType } from "../../../utils/API/getStaticPages";

// TruncatedText Component
const TruncatedText = ({ text, wordLimit }) => {
  const truncate = (str, limit) => {
    const words = str.split(" ");
    return words.length > limit ? words.slice(0, limit).join(" ") + "..." : str;
  };

  return (
    <p className="text-sm pl-3 font-bold truncate">
      {truncate(text, wordLimit)}
    </p>
  );
};

const docs = [
  {
    name: "signature",
    label: "Signature",
    number: 1,
    allowedFileTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf"
    ]
  }
];

const KycSignaturePopup = ({ open, onCancel, onSubmit, userData }) => {
  const [location, setLocation] = useState("");
  const [locationError, setLocationError] = useState("");
  const indentityProofLink = userData.documents.goverment_issued_id;
  const [documents, setDocuments] = useState({ signature: [] });
  const [signatureUploadError, setSignatureUploadError] = useState("");
  const [privacyPolicyContent, setPrivacyPolicyContent] = useState("");
  const [tncContent, setTncContent] = useState("");

  const handleIndentityProofView = () => {
    if (indentityProofLink) {
      window.open(indentityProofLink, "_blank");
    }
  };

  const fetchStatickycPpContent = async () => {
    try {
      const response = await getContentByType("kycPrivacyPolicy", {});
      if (response && response.content) {
        setPrivacyPolicyContent(response.content.pageContent);
      } else {
        console.error("Invalid response format:", response);
      }
    } catch (error) {
      console.error("Error fetching aboutsUs content:", error);
    }
  };

  const fetchStatickycTncContent = async () => {
    try {
      const response = await getContentByType("kycTnC", {});
      console.log("API Response:", response);

      if (response && response.content) {
        setTncContent(response.content.pageContent);
      } else {
        console.error("Invalid response format:", response);
      }
    } catch (error) {
      console.error("Error fetching aboutsUs content:", error);
    }
  };

  useEffect(() => {
    fetchStatickycPpContent();
    fetchStatickycTncContent();
  }, []);

  // useEffect(() => {
  //   console.log("User Data is ", userData);
  // });

  const handleSubmit = () => {
    let hasError = false;
    if (location === "" || documents.signature.length === 0) {
      hasError = true;
      if (documents.signature.length === 0) {
        setSignatureUploadError("Please upload the signature first");
        console.log("signature error");
      } else {
        setSignatureUploadError("");
      }
      if (location === "") {
        setLocationError("Please fill the location");
        console.log("location error");
      } else {
        setLocationError("");
      }
    }

    if (!hasError) {
      setSignatureUploadError("");
      setLocationError("");
      console.log("Form submitted successfully!");
      onCancel();
      onSubmit({ location, signature: documents.signature[0].url });
    }
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <div>
      <DiaglogBox open={open} onCancel={onCancel} width={600}>
        <div className="h-[550px] overflow-y-auto scrollbar-hide">
          <div className="text-2xl font-bold mb-4 px-7 pt-7">
            KYC Declaration
          </div>
          <Line />

          {userData.notAnOrganization ? (
            <div className="px-7 py-4">
              <div className="text-xl font-bold pb-2 ">Basic information</div>
              <div className="flex py-1">
                <p className="text-sm font-light w-44">Contact Name -</p>
                {userData.basicInformationContactName ? (
                  <p className="text-sm font-bold truncate">
                    {userData.basicInformationContactName}
                  </p>
                ) : (
                  <p> NA </p>
                )}
              </div>
              <div className="flex py-1">
                <p className="text-sm font-light w-44">Contact Details -</p>
                {userData.basicInformationContactDetailsPhoneCode ? (
                  <p className="text-sm font-bold truncate">
                    {userData.basicInformationContactDetailsPhoneCode}
                  </p>
                ) : (
                  <p> NA </p>
                )}

                {userData.basicInformationContactDetailsContactNumber ? (
                  <p className="text-sm pl-1 font-bold truncate">
                    {userData.basicInformationContactDetailsContactNumber}
                  </p>
                ) : (
                  <p> NA </p>
                )}
              </div>

              <div className="flex py-1">
                <p className="text-sm font-light w-44">Email -</p>
                {userData.basicInformationContactDetailsEmail ? (
                  <p className="text-sm font-bold truncate">
                    {userData.basicInformationContactDetailsEmail}
                  </p>
                ) : (
                  <p> NA </p>
                )}
              </div>
              <div className="flex py-1">
                <p className="text-sm font-light w-44">Address -</p>
                {userData.basicInformationAddressLine ? (
                  <p className="text-sm font-bold truncate">
                    {userData.basicInformationAddressLine}
                  </p>
                ) : (
                  // <TruncatedText
                  //   text={`${userData.basicInformationAddressLine} `}
                  //   wordLimit={10}
                  // />
                  <p> NA </p>
                )}
              </div>
              <div className="flex py-1">
                <p className="text-sm font-light w-44">City -</p>
                {userData.basicInformationCity ? (
                  <p className="text-sm font-bold truncate">
                    {userData.basicInformationCity}
                  </p>
                ) : (
                  // <TruncatedText
                  //   text={` ${userData.basicInformationCity}`}
                  //   wordLimit={10}
                  // />
                  <p> NA </p>
                )}
              </div>
              <div className="flex py-1">
                <p className="text-sm font-light w-44">State -</p>
                {userData.basicInformationState ? (
                  <p className="text-sm font-bold truncate">
                    {userData.basicInformationState},$
                    {userData.basicInformationCountry}
                  </p>
                ) : (
                  // <TruncatedText
                  //   text={` ${userData.basicInformationState} ,${userData.basicInformationCountry}
                  // `}
                  //   wordLimit={10}
                  // />
                  <p> NA </p>
                )}
              </div>
              <div className="flex py-1">
                <p className="text-sm font-light w-44">Pincode -</p>
                {userData.basicInformationPincode ? (
                  <p className="text-sm font-bold truncate">
                    {userData.basicInformationPincode}
                  </p>
                ) : (
                  // <TruncatedText
                  //   text={` ${userData.basicInformationPincode}`}
                  //   wordLimit={10}
                  // />
                  <p> NA </p>
                )}
              </div>
              <div className="flex py-1">
                <p className="text-sm font-light w-44">Pan ID -</p>
                {userData.basicInformationPanId ? (
                  <p className="text-sm font-bold truncate">
                    {userData.basicInformationPanId}
                  </p>
                ) : (
                  <p> NA </p>
                )}
              </div>
            </div>
          ) : (
            <div>
              <div className="px-7 py-4">
                <div className="text-xl font-bold pb-2 ">
                  Organizational Information
                </div>

                <div className="flex py-1">
                  <p className="text-sm font-light w-44">Company Type -</p>
                  {userData.organizationInformationCompanyType ? (
                    <p className="text-sm font-bold truncate">
                      {userData.organizationInformationCompanyType}
                    </p>
                  ) : (
                    <p> NA </p>
                  )}
                </div>
                <div className="flex py-1">
                  <p className="text-sm font-light w-44">Company Name -</p>
                  {userData.organizationInformationOrganizationName ? (
                    <p className="text-sm font-bold truncate">
                      {userData.organizationInformationOrganizationName}
                    </p>
                  ) : (
                    <p> NA </p>
                  )}
                </div>
                <div className="flex py-1">
                  <p className="text-sm font-light w-44">Address -</p>
                  {userData.organizationInformationAddressLine ? (
                    <p className="text-sm font-bold truncate ">
                      {`${userData.organizationInformationAddressLine}, ${userData.organizationInformationCity}, ${userData.organizationInformationState} ${userData.organizationInformationPincode}, ${userData.organizationInformationCountry}
                `}
                    </p>
                  ) : (
                    <p> NA </p>
                  )}
                </div>
                <div className="flex py-1">
                  <p className="text-sm font-light w-44">CIN -</p>
                  {userData.organizationInformationCompanyRegisteredAddress ? (
                    <p className="text-sm font-bold truncate">
                      {userData.organizationInformationCompanyRegisteredAddress}
                    </p>
                  ) : (
                    <p> NA </p>
                  )}
                </div>
                <div className="flex py-1">
                  <p className="text-sm font-light w-44">VAT/Tax ID -</p>
                  {userData.organizationInformationCompanyTaxId ? (
                    <p className="text-sm font-bold truncate">
                      {userData.organizationInformationCompanyTaxId}
                    </p>
                  ) : (
                    <p> NA </p>
                  )}
                </div>
                <div className="flex py-1">
                  <p className="text-sm font-light w-44">Pan ID -</p>
                  {userData.organizationInformationPanId ? (
                    <p className="text-sm font-bold truncate">
                      {userData.organizationInformationPanId}
                    </p>
                  ) : (
                    <p> NA </p>
                  )}
                </div>
                <div className="flex py-1">
                  <p className="text-sm font-light w-44">DUNS Number -</p>
                  {userData.organizationInformationDunsNumber ? (
                    <p className="text-sm font-bold truncate">
                      {userData.organizationInformationDunsNumber}
                    </p>
                  ) : (
                    <p> NA </p>
                  )}
                </div>
                <div className="flex py-1">
                  <p className="text-sm font-light w-44">Website -</p>
                  {userData.organizationInformationWebsiteLink ? (
                    <p className="text-sm font-bold truncate">
                      {userData.organizationInformationWebsiteLink}
                    </p>
                  ) : (
                    <p> NA </p>
                  )}
                </div>
                <div className="flex py-1">
                  <p className="text-sm font-light w-44">Contact no. -</p>
                  {userData.organizationInformationContactNumber ? (
                    <p className="text-sm font-bold truncate">
                      {userData.organizationInformationContactNumber}
                    </p>
                  ) : (
                    <p> NA </p>
                  )}
                </div>
                <div className="flex py-1">
                  <p className="text-sm font-light w-44">Email-id -</p>
                  {userData.organizationInformationEmail ? (
                    <p className="text-sm font-bold truncate">
                      {userData.organizationInformationEmail}
                    </p>
                  ) : (
                    <p> NA </p>
                  )}
                </div>
                <div className="flex py-1">
                  <p className="text-sm font-light w-44">Nature of Company -</p>
                  {userData.organizationInformationNatureOfBussiness ? (
                    <p className="text-sm font-bold truncate ">
                      {`${userData.organizationInformationNatureOfBussiness}`}
                    </p>
                  ) : (
                    <p> NA </p>
                  )}
                </div>
              </div>
              <div className="bg-blue-200 mx-1">
                <div className="px-7 py-4">
                  <div className="text-xl font-bold pb-2">
                    Billing and SPOC information
                  </div>
                  <div className="flex py-1">
                    <p className="text-sm font-light w-44">Company Name -</p>
                    {userData.billingInformationOrganizationName ? (
                      <p className="text-sm font-bold truncate">
                        {userData.billingInformationOrganizationName}
                      </p>
                    ) : (
                      <p> NA </p>
                    )}
                  </div>
                  <div className="flex py-1">
                    <p className="text-sm font-light w-44">Address -</p>
                    {userData.billingInformationAddressLine ? (
                      <p className="text-sm font-bold truncate">
                        {`${userData.billingInformationAddressLine} , ${userData.billingInformationCity} , ${userData.billingInformationState} ${userData.billingInformationPincode} , ${userData.billingInformationCountry} `}
                      </p>
                    ) : (
                      <p> NA </p>
                    )}
                  </div>
                  <div className="flex py-1">
                    <p className="text-sm font-light w-44">CIN -</p>
                    {userData.billingCompanyRegisteredAddress ? (
                      <p className="text-sm font-bold truncate">
                        {userData.billingCompanyRegisteredAddress}
                      </p>
                    ) : (
                      <p> NA </p>
                    )}
                  </div>
                  <div className="flex py-1">
                    <p className="text-sm font-light w-44">VAT/Tax ID -</p>
                    {userData.billingInformationTaxId ? (
                      <p className="text-sm font-bold truncate">
                        {userData.billingInformationTaxId}
                      </p>
                    ) : (
                      <p> NA </p>
                    )}
                  </div>
                  <div className="flex py-1">
                    <p className="text-sm font-light w-44">
                      Contact Person name -
                    </p>
                    {userData.contactDetailsPersonName ? (
                      <p className="text-sm font-bold truncate">
                        {userData.contactDetailsPersonName}
                      </p>
                    ) : (
                      <p> NA </p>
                    )}
                  </div>

                  <div className="flex py-1">
                    <p className="text-sm font-light w-44">Identity proof -</p>
                    <div className="flex justify-end gap-2 text-xs">
                      <Button
                        color="blue"
                        varient="secondary"
                        className="text-white w-20 text-xs "
                        onClick={handleIndentityProofView}
                      >
                        View
                      </Button>
                      <DownloadButton
                        fileUrl={userData.documents.goverment_issued_id}
                      />
                    </div>
                  </div>
                  <div className="flex py-1">
                    <p className="text-sm font-light w-44">Contact no. -</p>
                    {userData.contactDetailsContactNumber ? (
                      <p className="text-sm font-bold truncate">
                        {userData.contactDetailsContactNumber}
                      </p>
                    ) : (
                      <p> NA </p>
                    )}
                  </div>
                  <div className="flex py-1">
                    <p className="text-sm font-light w-44">Email-id -</p>
                    {userData.contactDetailsEmail ? (
                      <p className="text-sm font-bold truncate">
                        {userData.contactDetailsEmail}
                      </p>
                    ) : (
                      <p> NA </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="px-7 pb-3">
            <div className="text-xl font-bold pb-2 py-4">
              Terms and condition
            </div>

            {tncContent ? (
              <div dangerouslySetInnerHTML={{ __html: tncContent }} />
            ) : (
              <>
                <p className="text-[13px] font-normal pr-8  ">
                  Help protect your website and its users with clear and fair
                  website terms and conditions. These terms and conditions for a
                  website set out key issues such as acceptable use, privacy,
                  cookies, registration and passwords, intellectual property,
                  links to other sites, termination and disclaimers of
                  responsibility. Terms and conditions are used and necessary to
                  protect a website owner from liability of a user relying on
                  the information or the goods provided from the site then
                  suffering a loss.
                </p>
                <p className="text-[13px] font-normal pr-8 pt-5">
                  Making your own terms and conditions for your website is hard,
                  not impossible, to do. It can take a few hours to few days for
                  a person with no legal background to make. But worry no more;
                  we are here to help you out.
                </p>
                <p className="text-[13px] font-normal pr-8 pt-5">
                  All you need to do is fill up the blank spaces and then you
                  will receive an email with your personalized terms and
                  conditions.
                </p>
              </>
            )}
          </div>

          <div className="px-7 pb-3 bg-blue-200 mx-1">
            <div className="text-xl font-bold pb-2 py-4">Privacy Policy</div>

            {privacyPolicyContent ? (
              <div dangerouslySetInnerHTML={{ __html: privacyPolicyContent }} />
            ) : (
              <>
                <p className="text-[13px] font-normal pr-8  ">
                  Help protect your website and its users with clear and fair
                  website terms and conditions. These terms and conditions for a
                  website set out key issues such as acceptable use, privacy,
                  cookies, registration and passwords, intellectual property,
                  links to other sites, termination and disclaimers of
                  responsibility. Terms and conditions are used and necessary to
                  protect a website owner from liability of a user relying on
                  the information or the goods provided from the site then
                  suffering a loss.
                </p>
                <p className="text-[13px] font-normal pr-8 pt-5">
                  Making your own terms and conditions for your website is hard,
                  not impossible, to do. It can take a few hours to few days for
                  a person with no legal background to make. But worry no more;
                  we are here to help you out.
                </p>
                <p className="text-[13px] font-normal pr-8 pt-5">
                  All you need to do is fill up the blank spaces and then you
                  will receive an email with your personalized terms and
                  conditions.
                </p>
              </>
            )}
          </div>

          <div>
            <div className="flex justify-between py-4 px-7">
              <div>
                <UploadDocumentItem
                  label="Signature"
                  name="signature"
                  number={1}
                  setDocuments={setDocuments}
                  uploadList={documents.signature}
                  allowedFileTypes={docs[0].allowedFileTypes}
                  bottomLine={false}
                  labelWidth={false}
                />
                {signatureUploadError !== "" && (
                  <p className="text-xs text-red-500">{signatureUploadError}</p>
                )}
              </div>
              <div>
                <div className="flex justify-start">
                  <label htmlFor="location" className="text-sm font-semibold ">
                    Location -{" "}
                  </label>
                  <Input
                    type="text"
                    className="w-52 mx-2"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                  />
                </div>
                {locationError !== "" && (
                  <p className="text-xs text-red-500">{locationError}</p>
                )}
              </div>
            </div>
          </div>

          <div className="text-center ">
            <Button
              variant="primary"
              color="blue"
              className="mt-2 w-64 h-10 mb-2 inline-block text-white text-center text-base font-bold leading-4 mx-2 rounded-md"
              onClick={handleSubmit}
            >
              Submit
            </Button>
            <Button
              variant="primary"
              color="white"
              className="w-64 h-10 mb-2 inline-block text-blue-500 text-center text-base font-bold leading-4 mx-2 border border-solid border-blue-500 rounded-md"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </div>
        </div>
      </DiaglogBox>
    </div>
  );
};

export default KycSignaturePopup;
